import React, { useState, useEffect } from "react";
import { Field, FieldProps } from "formik";
import { Input } from "antd";
import InputValidationError from "../../InputValidationError/InputValidationError";
import { InputProps } from "antd/lib/input";
import Label from "../Label/Label";

type Props = InputProps & {
  label: string;
  name: string;
  InputComponent?: React.ReactElement<
    Omit<
      InputProps,
      | "prefix"
      | "size"
      | "type"
      | "addonBefore"
      | "addonAfter"
      | "prefix"
      | "suffix"
      | "allowClear"
      | "prefixCls"
    >
  >;
};

const FormikTextField: React.FC<Props> = ({
  name,
  label,
  required,
  InputComponent,
  ...rest
}) => {
  if (InputComponent && InputComponent.props.children)
    throw Error(
      "InputComponent must be a single element and can not contain children"
    );

  return (
    <>
      <Field name={name}>
        {({ field, form, meta }: FieldProps<any, any>) => {
          const error = !!meta.error && meta.touched;
          return (
            <>
              <Label
                text={label}
                htmlFor={name}
                required={required}
                error={error}
              />
              {InputComponent ? (
                React.cloneElement(InputComponent, {
                  className: "ant-input ant-input",
                  style: { borderColor: error ? "red" : "" },
                  ...field,
                  ...rest,
                  ...InputComponent.props,
                  id: name,
                  onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
                    // If we don't call this, validation is not run when blurred!
                    field.onBlur(e);
                    if (InputComponent.props.onBlur)
                      InputComponent.props.onBlur(e);
                  },
                })
              ) : (
                <Input
                  id={name}
                  required={required}
                  {...rest}
                  {...field}
                  onBlur={(evt) => {
                    field.onBlur(evt);
                    if (rest.onBlur) {
                      rest.onBlur(evt);
                    }
                  }}
                  // style={{ borderColor: error ? "red" : "" }}
                />
              )}
            </>
          );
        }}
      </Field>
      <InputValidationError name={name} />
    </>
  );
};

export default FormikTextField;
